var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocNotesDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1432 0H2.33105V20H17.6696V3.50633L14.1432 0ZM13.918 1.42859L16.1741 3.67188H13.918V1.42859ZM16.4977 18.8281H3.50293V1.17188H12.7461V4.84375H16.4977V18.8281H16.4977Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92773 14.6875H12.0731V15.8594H7.92773V14.6875Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69141 11.6016H14.3082V12.7734H5.69141V11.6016Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69141 8.51562H14.3082V9.6875H5.69141V8.51562Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69141 5.42969H9.99984V6.60156H5.69141V5.42969Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocNotesDark);
export default __webpack_public_path__ + "static/media/ic-doc-notes-dark.fbb983659083c93f0c5e810467ed75d6.svg";
export { ForwardRef as ReactComponent };